<div class="mesh-header">
  <button class="mode-toggle"
    [class.solo-mode]="!meshPublic"
    [class.shield-mode]="!!meshPublic"
    [style.--shield-color]="shieldColor()"
    type="button"
    (click)="onToggle()">
    <span class="mat-sym" [class.filled]="meshPublic">{{ meshPublic ? 'groups' : 'person' }}</span>
  </button>
</div>
